document.addEventListener("DOMContentLoaded", function () {
  const form = document.getElementById("footerCatalogForm");
  const messageDiv = document.getElementById("footerCatalogMessage");

  if (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();

      const email = document.getElementById("catalogEmail").value;
      const formData = new FormData();

      formData.append("action", "catalog_request");
      formData.append("nonce", footerCatalogVars.nonce);
      formData.append("email", email);

      fetch(footerCatalogVars.ajaxUrl, {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((data) => {
          messageDiv.textContent = data.success
            ? footerCatalogVars.messages.success
            : footerCatalogVars.messages.error;

          messageDiv.className =
            "footer-cta-message " + (data.success ? "success" : "error");

          if (data.success) {
            form.reset();
          }
        })
        .catch(() => {
          messageDiv.textContent = footerCatalogVars.messages.error;
          messageDiv.className = "footer-cta-message error";
        });
    });
  }
});
